var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.68661 6.31333L6.31328 9.68666C5.87995 9.25333 5.61328 8.65999 5.61328 7.99999C5.61328 6.67999 6.67995 5.61333 7.99995 5.61333C8.65995 5.61333 9.25328 5.87999 9.68661 6.31333Z",
    stroke: "#878299",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8799 3.84666C10.7132 2.96666 9.3799 2.48666 7.9999 2.48666C5.64656 2.48666 3.45323 3.87333 1.92656 6.27333C1.32656 7.21333 1.32656 8.79333 1.92656 9.73333C2.45323 10.56 3.06656 11.2733 3.73323 11.8467",
    stroke: "#878299",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.61328 13.02C6.37328 13.34 7.17995 13.5133 7.99995 13.5133C10.3533 13.5133 12.5466 12.1267 14.0733 9.72667C14.6733 8.78667 14.6733 7.20667 14.0733 6.26667C13.8533 5.92 13.6133 5.59333 13.3666 5.28667",
    stroke: "#878299",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3135 9.68666L1.3335 14.6667",
    stroke: "#878299",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6665 1.33333L9.68652 6.31333",
    stroke: "#878299",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeDark);
export default __webpack_public_path__ + "static/media/eye-dark.f3171c2bf5be1f4ddfd0d747b8f54de8.svg";
export { ForwardRef as ReactComponent };